module.exports = __webpack_public_path__ + "img/destination-10.4602c115.svg";